import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { placeholder: String }

  connect() {
    if (this.element.tomselect) return
    // Wrap in erp-select for scoped styling
    this.element.parentElement.classList.add("erp-select")

    this.select = new TomSelect(this.element, {
      create: false,
      // The prompt belongs in the placeholder, not in the option list: an empty entry showing
      // up among the search results is noise.
      placeholder: this.placeholderValue,
      allowEmptyOption: false,
      controlInput: "<input>"
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.select = null
    }
    this.element.parentElement.classList.remove("erp-select")
  }
}
